import { Alert } from '/src/lib/models';

export enum AlertStatus {
  Unread = 'unread',
  Read = 'read',
}

/**
 * List Alerts
 */
export type TListAlertsRequest = {
  px?: string[];
};

export type TListAlertsResponse = Alert[];

/**
 * Get Alert
 */
export type TGetAlertResponse = Alert;

/**
 * Update Alert
 */
export type TUpdateAlertRequest = Alert;

export type TUpdateAlertResponse = Alert;
